module.exports = __webpack_public_path__ + "img/finance-card.8a327f5f.svg";